import { DataFormats } from '@skylab-shared/constants';
import { TransformFnParams } from 'class-transformer';
import { parse } from 'fecha';
import { isDate, isDateTime, isIsoDateTime } from './date-utils';

export const addUtcTimeZoneInfo = (strDate: string): string => `${strDate}Z`;

export function transformDTODate({value}: TransformFnParams): Date | null {
    if (!value) return null;

    if (isDate(value)) return parse(value, DataFormats.date.webApi) || null;
    if (isDateTime(value)) return parse(addUtcTimeZoneInfo(value), DataFormats.date.webApiDateTimeWithTimeZone) || null;
    if (isIsoDateTime(value)) return parse(value, DataFormats.date.webApiDateTimeWithTimeZone) || null;

    return null;
}
